module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin2-5cd7cc30290a55951288594bfb3d6efb.jpg";